import React, { useEffect, useRef } from 'react';
import cls from './Option.module.css';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export const Option = ({ option, onClick, setIsOpen, isActive }) => {
    const { t } = useTranslation();
    const optionRef = useRef(null);
    const handleClick = (clickedValue, event) => {
        if (!option.isDisabled) {
            if (option.isButton) {
                option.buttonHandler();
            } else {
                onClick(clickedValue);
                setIsOpen(false);
            }
        } else {
            event.stopPropagation();
        }
    };

    useEffect(() => {
        const option = optionRef.current;
        if (!option) return;

        const handleEnterPress = (event) => {
            if (document.activeElement === option && event.key === 'Enter') {
                onClick(option.value);
            }
        };

        option.addEventListener('keydown', handleEnterPress);

        return () => {
            option.removeEventListener('keydown', handleEnterPress);
        };
    }, [option.value, onClick]);

    return (
        <li
            ref={optionRef}
            className={classNames(cls.option, {
                [cls.head]: option.isHead,
                [cls.disabledOption]: option.isDisabled,
                [cls.button]: option.isButton,
                [cls.active]: isActive,
            })}
            value={option.value}
            onClick={(e) => handleClick(option.value, e)}
            tabIndex={0}
        >
            {/*<span className={classNames(cls.svgWrapper)}>{!!option.icon && option.icon}</span>*/}
            <span
                className={classNames(cls.optionSpan, {
                    [cls.archiveOption]: option.account.is_archive,
                })}
            >
                {option.title}
            </span>
            {option.account.is_archive && (
                <span className={classNames(cls.optionArchiveSpan)}>
                    {t('Option.Account.IsArchive')}
                </span>
            )}
        </li>
    );
};
